import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  key:'customersadd',
  path: '/charts/ec',
  title: 'ECharts',
  component: dynamicWrapper(app, [], () => import('./components'))
});

export default app => createRoute(app, routesConfig);
